//plays a file in loop when in DOM.
export function AudioPlayer(props: { fileName: string }) {
  return (
    <>
      <audio loop autoPlay>
        <source src={props.fileName} type="audio/ogg" />
        Your browser does not support the audio element.
      </audio>
    </>
  );
}
